export const dropdownSettings = {
  roles: { url: 'list/roles' },
  runs: { url: 'list/runs' },
  exceptionTypes: { url: 'list/exceptionTypes' },
  exceptions: { url: 'jobexception/manual' },
  depots: { url: 'list/depots' },
  scenarios: { url: 'list/scenarios' },
  orderAttributes: { url: 'list/orderAttributes' },
  vehicleAttributes: { url: 'list/vehicleAttributes' },
  mapPublications: { url: 'geocode/mappublication' },
  vehicles: { url: 'list/vehicles' },
  compartments: { url: 'list/compartments' },
  portalClients: { url: 'list/portalClients' },
  dashboardWidgets: { url: 'list/dashboardWidgets' },
  bookingCustomers: { url: 'list/bookingCustomers' },
  reportingLocations: { url: 'list/reportingLocations' },
  runCategories: { url: 'list/runCategories' },
  colorCodes: { url: 'list/colorCodes' },
} as const

export type DropdownSettingsKey = keyof typeof dropdownSettings